/*
 * @Descripttion: 学生评价配置表 接口
 * @version: 1.0
 * @Author: Erik Zhang
 * @Date: 2021-04-21
 * @LastEditors: Erik Zhang
 * @LastEditTime: 2021-04-22 20:30:54
 */

import http from '@/utils/kq/http';

const veStuEvaluationConfigApi = {
  //添加接口
  add(data) {
    return http.post(http.service.stu + 'veStuEvaluationConfig/add', data);
  },
  //删除接口
  delete(ids) {
    return http.delete(http.service.stu + 'veStuEvaluationConfig/deleteBatch?ids=' + ids);
  },
  //修改接口
  update(data) {
    return http.put(http.service.stu + 'veStuEvaluationConfig/edit', data);
  },
  //分页查询接口
  page(pageData) {
    return http.post(http.service.stu + 'veStuEvaluationConfig/page', pageData);
  },
  //分页查询接口
  all(pageData) {
    return http.post(http.service.stu + 'veStuEvaluationConfig/all', pageData);
  },
  //查询单个数据接口
  get(id) {
    return http.get(http.service.stu + 'veStuEvaluationConfig/queryById', { id: id });
  },
  //更新状态
  updateStatus(data) {
    return http.post(http.service.stu + 'veStuEvaluationConfig/updateStatus', data);
  }
};
export default veStuEvaluationConfigApi;
